<template>
  <div>
    <parent-players-all
      v-if="tutorial === 'parent-players-all'"
    />
    <player-progress-students
      v-if="tutorial === 'player-progress-students'"
    />
    <player-progress-student
      v-if="tutorial === 'player-progress-student'"
    />
    <tuto-parent-students-groups
      v-if="tutorial === 'tuto-parent-students-groups'"
    />
    <tuto-teacher-students-groups
      v-if="tutorial === 'tuto-teacher-students-groups'"
    />
    <shop-my-products
      v-if="tutorial === 'shop-my-products'"
    />
    <tutor-players-all
      v-if="tutorial === 'tutor-players-all'"
    />
    <tutor-demo
      v-if="tutorial === 'tutor-demo'"
    />
    <tutor-demo-progress
      v-if="tutorial === 'tutor-demo-progress'"
    />
    <tutorial-group-statistics
      v-if="tutorial === 'tutorial-group-statistics'"
    />
    <teacher-assigned
      v-if="tutorial === 'teacher-assigned'"
    />
    <terms
      v-if="tutorial === 'terms'"
    />
    <politics
      v-if="tutorial === 'politics'"
    />
  </div>
</template>
<script>
  import ParentPlayersAll from '@/views/dashboard/tutorials/ParentPlayersAll'
  import PlayerProgressStudents from '@/views/dashboard/tutorials/PlayerProgressStudents'
  import PlayerProgressStudent from '@/views/dashboard/tutorials/PlayerProgressStudent'
  import TutoParentStudentsGroups from '@/views/dashboard/tutorials/TutoParentStudentsGroups/'
  import TutoTeacherStudentsGroups from '@/views/dashboard/tutorials/TutoTeacherStudentsGroups/'
  import ShopMyProducts from '@/views/dashboard/tutorials/ShopMyProducts'
  import TutorPlayersAll from '@/views/dashboard/tutorials/TutorPlayersAll'
  import TutorDemo from '@/views/dashboard/tutorials/TutorDemo'
  import TutorDemoProgress from '@/views/dashboard/tutorials/TutorDemoProgress'
  import TutorialGroupStatistics from '@/views/dashboard/tutorials/TutorialGroupStatistics'
  import TeacherAssigned from '@/views/dashboard/tutorials/TeacherAssigned'

  import Terms from '@/views/dashboard/tutorials/Terms'
  import Politics from '@/views/dashboard/tutorials/Politics'

  export default {
    components: {
      ParentPlayersAll,
      PlayerProgressStudents,
      PlayerProgressStudent,
      TutoParentStudentsGroups,
      TutoTeacherStudentsGroups,

      ShopMyProducts,
      TutorPlayersAll,
      TutorDemo,
      TutorDemoProgress,
      TutorialGroupStatistics,
      TeacherAssigned,

      Terms,
      Politics,
    },
    props: {
      tutorial: {
        type: String,
        default: '',
      },
    },
  }
</script>
